import { h } from 'preact'
export const FiltersIcon = () => {
    return (
      <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1">
          <g id="B2---PLP-&amp;-Filter/Sort" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="PLP---Desktop---1-Col-Promo---50/50-Image" transform="translate(-1230.000000, -467.000000)" fill="#FFFFFF">
                  <g id="Group-5-Copy-8" transform="translate(1230.000000, 467.000000)">
                      <polygon id="Fill-1" points="5.182 10.441 13.375 10.441 13.375 8.941 5.182 8.941"></polygon>
                      <polygon id="Fill-2" points="0 3.731 8.193 3.731 8.193 2.231 0 2.231"></polygon>
                      <polygon id="Fill-3" points="9.2844 0 9.2844 2.231 9.2844 3.731 9.2844 5.963 10.7834 5.963 10.7834 3.731 13.3744 3.731 13.3744 2.231 10.7834 2.231 10.7834 0"></polygon>
                      <polygon id="Fill-4" points="2.5911 6.7086 2.5911 8.9406 0.0001 8.9406 0.0001 10.4406 2.5911 10.4406 2.5911 12.6716 4.0911 12.6716 4.0911 10.4406 4.0911 8.9406 4.0911 6.7086"></polygon>
                  </g>
              </g>
          </g>
      </svg>
    )
}
